/**
 * General helper utilities for the grid widget
 */

export function readBoolAttr(el, name, dflt = false) {
  if (!el) return dflt;
  const v = (el.getAttribute(name) || "").trim().toLowerCase();
  if (!v) return dflt;
  return v === "true" || v === "1" || v === "yes" || v === "on";
}

export function readIntAttr(el, name) {
  if (!el) return undefined;
  const raw = el.getAttribute(name);
  if (raw == null) return undefined;
  const n = parseInt(String(raw).trim(), 10);
  return Number.isFinite(n) ? n : undefined;
}

export const truthy = (v, dflt = false) =>
  v == null ? dflt : /^(1|true|yes|on)$/i.test(String(v));

export function currencySymbol(code) {
  const map = {
    GBP: "£", EUR: "€", USD: "$", CAD: "$", AUD: "$", NZD: "$",
    JPY: "¥", CNY: "¥", INR: "₹", KRW: "₩", THB: "฿",
    IDR: "Rp", MYR: "RM", PHP: "₱", BRL: "R$", MXN: "$",
    SEK: "kr", NOK: "kr", DKK: "kr", CHF: "CHF", ZAR: "R",
    TRY: "₺", PLN: "zł", CZK: "Kč", HUF: "Ft", AED: "د.إ", SAR: "﷼"
  };
  return map[String(code || "").toUpperCase()] || (code || "");
}

export function normalizeImageSize(v) {
  const s = String(v || "md").toLowerCase();
  if (["s", "sm", "small"].includes(s)) return "s";
  if (["l", "lg", "large", "xl"].includes(s)) return "l";
  return "md"; // default
}

export function pickImageByPref(pic, pref) {
  if (!pic || typeof pic !== "object") return "";
  const candidates =
    pref === "s"
      ? [pic.small, pic.sm, pic.thumb, pic.thumbnail, pic.url_small, pic.urlSmall]
      : pref === "l"
      ? [pic.large, pic.lg, pic.xl, pic.full, pic.url_large, pic.urlLarge]
      : [pic.medium, pic.md, pic.url_medium, pic.urlMedium]; // "md" default

  const fallback = [pic.url, pic.large, pic.medium, pic.small];
  const chosen = [...candidates, ...fallback].find(Boolean);
  return chosen || "";
}

/** Get all available image sizes for srcset */
export function getImageSrcset(pic) {
  if (!pic || typeof pic !== "object") return null;
  const small = pic.small || pic.sm || pic.thumb || pic.url_small || pic.urlSmall;
  const medium = pic.medium || pic.md || pic.url_medium || pic.urlMedium;
  const large = pic.large || pic.lg || pic.xl || pic.full || pic.url_large || pic.urlLarge;
  const parts = [];
  if (small) parts.push(`${small} 400w`);
  if (medium) parts.push(`${medium} 800w`);
  if (large) parts.push(`${large} 1200w`);
  return parts.length > 1 ? parts.join(", ") : null;
}

export function normalizeMapStyle(s) {
  const v = String(s || "").trim().toLowerCase();
  if (!v) return undefined;
  if (v === "carto-dark") return "carto-dark";
  if (v === "carto-light") return "carto-light";
  if (v === "openstreetmap" || v === "osm" || v === "default") return "default";
  if (v === "dark") return "dark";
  if (v === "light") return "light";
  if (v === "streets") return "streets";
  if (v === "satellite") return "satellite";
  return v;
}
